import { render, staticRenderFns } from "./ListaCarteiras.vue?vue&type=template&id=1cb8d39c"
import script from "./ListaCarteiras.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaCarteiras.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports